import React from "react";

function HelpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 372.309 372.309"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M221.77,234.462l-86.911-12.036l-34.056-34.053c-0.002-0.001-0.004-0.003-0.005-0.005c-1.261-1.264-1.262-3.318-0.01-4.573
		c0.824-0.823,1.788-0.946,2.289-0.946c0.498,0,1.456,0.122,2.271,0.939c0.002,0.002,0.004,0.003,0.005,0.005l0.001,0.001
		l25.749,25.748c0.001,0.001,0.002,0.001,0.003,0.002c0.001,0.001,0.002,0.003,0.003,0.003c0.074,0.074,0.155,0.135,0.23,0.208
		c0.111,0.103,0.221,0.21,0.338,0.305c3.78,3.493,8.594,5.261,13.422,5.261c5.07,0,10.145-1.928,14.01-5.784
		c7.712-7.726,7.71-20.29-0.005-28.006l-70.687-70.687c-1.407-1.407-3.314-2.197-5.304-2.197H7.5c-4.143,0-7.5,3.358-7.5,7.5
		s3.357,7.5,7.5,7.5h72.508l68.489,68.489c1.872,1.873,1.87,4.925,0.007,6.792c-1.875,1.87-4.927,1.87-6.8,0
		c-0.003-0.003-0.007-0.006-0.01-0.009l-25.724-25.723c-0.002-0.001-0.004-0.003-0.005-0.005c-0.002-0.002-0.004-0.003-0.005-0.005
		l-0.001-0.001c-0.003-0.003-0.007-0.006-0.01-0.009c-3.437-3.436-8.007-5.328-12.873-5.328c-4.869,0-9.447,1.895-12.898,5.342
		c-6.907,6.921-7.065,18.064-0.511,25.205c0.043,0.054,0.094,0.102,0.14,0.155c0.126,0.135,0.237,0.278,0.369,0.41
		c0.002,0.003,0.005,0.004,0.007,0.006c0,0.001,0,0.001,0.001,0.001l35.849,35.846c1.155,1.155,2.655,1.901,4.274,2.125
		l89.338,12.371c1.683,0.249,4.864,1.373,4.864,3.857c0.002,1.355-0.688,2.247-1.099,2.659c-0.413,0.413-1.309,1.106-2.67,1.106
		h-99.917l-79.523-79.533c-1.406-1.406-3.314-2.197-5.304-2.197H7.5c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h25.391
		l79.523,79.533c1.406,1.406,3.314,2.197,5.304,2.197h103.023c5.019,0,9.735-1.955,13.282-5.505
		c3.543-3.547,5.492-8.262,5.486-13.268C239.51,243.694,232.242,236.009,221.77,234.462z"
        />
        <path
          d="M364.809,248.661h-72.508l-68.489-68.489c-1.872-1.873-1.87-4.925-0.007-6.793c1.875-1.87,4.927-1.87,6.8,0
		c0.003,0.003,0.007,0.006,0.01,0.009l25.724,25.723c0.002,0.001,0.004,0.003,0.005,0.005c0.002,0.002,0.004,0.003,0.005,0.005
		l0.001,0.001c0.003,0.003,0.007,0.005,0.01,0.009c3.436,3.436,8.007,5.329,12.873,5.329c4.869,0,9.447-1.895,12.898-5.342
		c6.907-6.921,7.065-18.063,0.511-25.205c-0.043-0.054-0.094-0.102-0.14-0.155c-0.126-0.135-0.237-0.278-0.369-0.41
		c-0.002-0.003-0.005-0.004-0.007-0.006l-0.001-0.001l-35.849-35.846c-1.155-1.155-2.655-1.901-4.274-2.125l-89.338-12.371
		c-1.683-0.249-4.864-1.373-4.864-3.857c-0.002-1.355,0.688-2.247,1.099-2.659c0.413-0.413,1.309-1.106,2.67-1.106h99.917
		l79.523,79.533c1.406,1.406,3.314,2.197,5.304,2.197h28.497c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5h-25.391
		l-79.523-79.533c-1.406-1.406-3.314-2.197-5.304-2.197H151.567c-5.019,0-9.735,1.955-13.282,5.505
		c-3.543,3.547-5.492,8.262-5.486,13.268c0,9.466,7.268,17.151,17.74,18.698l86.911,12.036l34.056,34.053
		c0.002,0.001,0.004,0.003,0.005,0.005c1.261,1.264,1.262,3.318,0.01,4.573c-0.824,0.823-1.788,0.946-2.289,0.946
		c-0.498,0-1.456-0.122-2.271-0.939c-0.002-0.002-0.004-0.003-0.005-0.005l-0.001,0l-25.749-25.748
		c-0.001-0.001-0.002-0.002-0.003-0.002c-0.001-0.001-0.002-0.002-0.003-0.003c-0.07-0.07-0.147-0.128-0.219-0.197
		c-0.115-0.107-0.229-0.217-0.35-0.316c-7.75-7.16-19.885-7.003-27.432,0.524c-7.712,7.726-7.71,20.289,0.005,28.006l70.686,70.687
		c1.407,1.407,3.315,2.197,5.304,2.197h75.614c4.143,0,7.5-3.358,7.5-7.5C372.309,252.019,368.951,248.661,364.809,248.661z"
        />
      </g>
    </svg>
  );
}

export default HelpIcon;
